import palette from '../palette';
import typography from '../typography';

export default {
  root: {
    color: palette.icon,
    fontSize: '8px',
  },
  primary: {
    fontSize: typography.body2.fontSize,
    color: typography.body2.color,
  },
  secondary: {
    fontSize: typography.body1.fontSize,
    color: typography.body1.color,
    wordWrap: 'break-word',
  },
};
